// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryModelIcon from '../../../assets/new_gems/Category/GemCategoryModel.svg?inline';
import React from 'react';
export const GemCategoryModel = (props)=>{
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: gemCategoryModelIcon,
        alt: "GemCategoryModelImage"
    });
};
